import React from 'react';
import AnimationRevealPage from 'helpers/AnimationRevealPage.js';
import Footer from 'components/footers/MiniCenteredFooter.js';
import NavBar from 'components/navbars/basic.js';
import Posts from './BlogIndex.js';

export default () => (
  <AnimationRevealPage>
    <NavBar />
    <Posts />
    <Footer />
  </AnimationRevealPage>
);
